import React, { useMemo } from 'react'
import { UserType } from '../../api/auth-api'
import { AuthContext } from './auth-context'

// Allow Playwright to override the user type via a global variable
declare global {
  interface Window {
    __E2E_USER_TYPE__?: string // Store as string, e.g., 'BUYER' or 'ISSUER'
  }
}

interface AuthProviderMockProps {
  children: React.ReactNode
}

export const AuthProviderMock: React.FC<AuthProviderMockProps> = ({
  children,
}) => {
  const mockContextValue = useMemo(() => {
    let effectiveUserType: UserType = UserType.BUYER

    // Check if the global variable is set by Playwright
    const userType = window.__E2E_USER_TYPE__
    if (userType) {
      const e2eUserTypeString = userType
      if (e2eUserTypeString === 'ISSUER') {
        effectiveUserType = UserType.ISSUER
      } else if (e2eUserTypeString === 'BUYER') {
        effectiveUserType = UserType.BUYER
      }
    }

    return {
      userType: effectiveUserType,
      isLoading: false,
      error: null,
    }
  }, [])

  return <AuthContext value={mockContextValue}>{children}</AuthContext>
}
